export default __webpack_public_path__ + "static/media/musicGramLogo.2d8bc2ca.png";